import "./TeacherCard.css";

export default function TeacherCard({ photoUrl, name, description }) {
  return (
    <div className="containerTeacher">
      <div className="headers">
        <img src={photoUrl} alt="" className="imageProf" />
        <div className="containerText">
          <h3>{name}</h3>
        </div>
      </div>
      <div className="description">{description}</div>
    </div>
  )
}
